import React from 'react';

import { Translations } from '../task-inventory/task-inventory';
import _noop from 'lodash/noop';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface expandCollapseButtonProps {
	onClick?: () => void;
	isExpanded?: boolean;
	translations: Translations;
	isDisabled?: boolean;
}

const ExpandCollapseButton: React.FC<expandCollapseButtonProps> = ({
	onClick = _noop,
	isExpanded,
	translations,
	isDisabled
}) => {
	const expandCollapseTitle = isExpanded ? translations.collapseAll : translations.expandAll;
	return (
		<button
			type="button"
			disabled={isDisabled}
			className={classNames('expand-collapse-button', { expanded: isExpanded }, { disabled: isDisabled })}
			onClick={onClick}
		>
			<BringgIcon iconName={BringgFontIcons.ChevronRight} rotate90={isExpanded} className="arrow-icon" />
			<span>{expandCollapseTitle}</span>
		</button>
	);
};

export default ExpandCollapseButton;
